module.exports = __webpack_public_path__ + "img/intro-2.57f07d0a.png";